import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { NbIconLibraries, NbMenuItem, NbMenuService } from '@nebular/theme';
import { ContentElement, ContentStatusEnum, HorisontalAlign, VisibilityEnum } from '@urbannex/storethemes';
import { sectionEditorIcons } from '../section-editor-dialog/section-dialog-menu-items';
import { FontSizePopoverComponent } from '../font-size-popover/font-size-popover.component';
import { FontFamilyPopoverComponent } from '../font-family-popover/font-family-popover.component';
import { FontWeightPopoverComponent } from '../font-weight-popover/font-weight-popover.component';
import { ColorPickerPopoverComponent } from '../color-picker-popover/color-picker-popover.component';
import { PopoverData } from '../../../editor-container/editor-model';
import { PreviewEditStoreService } from '../../../services/preview-edit-store.service';
import { CellEditorStoreService } from '../../cell-editor-store.service';
import { SectionEditorStoreService } from '../section-editor-dialog/section-editor-store.service';

@Component({
  selector: 'kve-text-editor-popver',
  templateUrl: './text-editor-popver.component.html',
  styleUrls: ['./text-editor-popver.component.scss']
})
export class TextEditorPopverComponent implements OnInit {
  content:ContentElement;
  title:string;
  status:ContentStatusEnum;
  service:string;
  isEditing:boolean = false;
  text:string;
  textColor:string;
  bgColor:string;
  defaultTextColor:string;
  target:string;

  fontWeightPopoverContext: PopoverData = {
    title: '',
    popoverType: '',
    target: ''
  }

  textMenuItems:NbMenuItem[] = [
    {
      title:"Font Size",
      icon:{icon:"font-size",pack:"section-menu-icons"}
    },
    {
      title:"Color",
      icon:{icon:"text-color",pack:"section-menu-icons"}
    },
    {
      title:"Font-Family",
      icon:{icon:"font-family",pack:"section-menu-icons"}
    },
    {
      title:"Font Weight",
      icon:{icon:"font-weight",pack:"section-menu-icons"}
    }
  ]

  colorPop: any = ColorPickerPopoverComponent;

  fontSizePop:any = FontSizePopoverComponent;
  
  fontFamPop:any = FontFamilyPopoverComponent;
  
  fontWeight:any = FontWeightPopoverComponent;

  theme:string;
  HorisontalAlign = HorisontalAlign;

  alignments = [
    {name:"Align Left",class:"justify-left"},
    {name:"Align Center",class:"justify-center"},
    {name:"Align Right",class:"justify-right"}
  ]
  VisibilityEnum = VisibilityEnum;

  constructor(
    private iconLibraries: NbIconLibraries,
    private cellEditorStoreService:CellEditorStoreService,
    private sectionEditStore:SectionEditorStoreService,
    private previewEditStoreService: PreviewEditStoreService,
    private menuService:NbMenuService){
    this.iconLibraries.registerSvgPack('section-menu-icons',sectionEditorIcons);
    /* this.menuService.onItemClick().subscribe((menuBag) => {
      let menuTag = menuBag.tag;
      if(menuTag && menuTag === "sectionEditorMenu"){
        console.log(menuBag)
        this.showPopover(menuBag);
      }
    }) */
  }

  startEdit(){
    
  }

  setHorizontalAlign(newAlignment:HorisontalAlign){
    console.log("Setting horizontal alignment to:", newAlignment);
    this.service = this.service != undefined ? this.service : "section";
    //Clean up existing horizontal alignment classes if exists
    this.content = this.cleanUpClasses("alignment",this.content);
    //Add new horizontal alignment class
    this.content.classes.push(newAlignment.toString());
    switch (this.service) {
      case "section":
      case "sectionEditor":
      case "sectionEditorStoreService":
      case "sectionStore":
        console.log("Executing section service:");
        this.content.horizontalAlign = newAlignment;
        this.sectionEditStore.updateTitle({...this.content});
        break;
      case "cell":
        console.log("Executing section service:");
        this.sectionEditStore.updateTitle({...this.content, horizontalAlign: newAlignment});
        break;
      default:
        console.warn("Unknown service for horizontal alignment update:", this.service);
    }
/*     this.content.horizontalAlign = align;
    this.content.horizontalAlign = align;
    this.previewEditStoreService.updateContent(this.content); */
  }
  
  ngOnInit(): void {
    console.log(this.service)
    /**
     * Get the theme
     */
    this.previewEditStoreService.selectedSite$.subscribe(site => {
      let themeName = site.theme.name;
      this.theme = 'nb-theme-'+themeName
    })
    /**
     * Get the target using the service
     */
    if(this.service == "cellEditorStoreService"){
      this.cellEditorStoreService.activeSelector$.subscribe(content => {
        if(content){
          this.content = content;
          console.log(this.content)
        }else{
          if(this.target && this.target == "content" || this.target == "contentElement"){
            this.cellEditorStoreService.selectedCell$.subscribe(cell => {
              if(cell){
                if(cell.contentElements && cell.contentElements.length > 0){
                  this.content = cell.contentElements[0];
                }
              }
            })
          }
        }
      })
    }
    
    console.log(this.content)
    console.log('Text Editor Popover Initialized');
    console.log('Title',this.title)
    this.text = this.content.text || 'Text Here'
    this.textColor = this.content?.color != undefined ? this.content?.color : undefined;
    this.bgColor = this.content?.background != undefined ? this.content?.background : undefined;
  }

  cleanUpClasses(classType:string,content:ContentElement):ContentElement{
  //Remove all classes of the specified type
  //First check if classes array exists and has members
    if(content.classes && content.classes.length > 0){
      //Filter out classes that match the classType
      //First use the classType to identify the array to be used for the filtering
      if(classType === "alignment"){
        //Remove all horizontal alignment classes
        content.classes = content.classes.filter(cls => !cls.includes("justify-"));
      }
    }

    return content

  }

  handleUpdateContent(e:ContentElement){
    console.log(e)
    this.content = {...e};
    console.log(this.service)
    console.log('Updated Content:', this.content);
    switch (this.service) {
      case "section":
      case "sectionEditor":
      case "sectionEditorStoreService":
      case "sectionStore":
        console.log("Executing section service:");
        this.sectionEditStore.updateTitle({...this.content});
        break;
      case "cell":
      case "cellEditorStoreService":  
        console.log("Executing section service:");
        this.sectionEditStore.updateTitle({...this.content});
        break;
      default:
        console.warn("Unknown service for horizontal alignment update:", this.service);
    }
  }
  onVisibilityChange(visibility: VisibilityEnum,target:string){
    console.log(visibility,this.content)
    this.content = {...this.content,visibility}
    switch (this.service) {
      case "section":
      case "sectionEditor":
      case "sectionEditorStoreService":
      case "sectionStore":
        console.log("Executing section service:");
        this.sectionEditStore.updateTitle({...this.content});
        break;
      case "cell":
        console.log("Executing cell service:");
        this.cellEditorStoreService.updateActiveSelector({...this.content})
        //this.sectionEditStore.updateTitle({...this.content});
        break;
      default:
        console.warn("Unknown service for horizontal alignment update:", this.service);
    }
  }

}
